export const getAriaLabelKey = ({ isSaved }) =>
  isSaved
    ? "plp_web_save_for_later_active"
    : "plp_web_search_save_for_later_label";
